<template>
  <div
    class="admin-hub-banner flex w-full items-center justify-center gap-4 bg-green-600 px-4 py-2 text-center text-sm font-semibold text-white md:text-base"
    role="status"
  >
    <span class="flex items-center gap-2">
      <i class="pi pi-user" />
      <span>{{ bannerText }}</span>
    </span>

    <Button
      :label="t('nav.adminHubLogout')"
      icon="pi pi-sign-out"
      size="small"
      severity="contrast"
      outlined
      @click="onLogout"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Button from 'primevue/button'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'

const { t } = useI18n()
const authStore = useAuthStore()

const bannerText = computed(() =>
  authStore.adminHubCustomerName
    ? t('nav.adminHubBanner', { name: authStore.adminHubCustomerName })
    : t('nav.adminHubBannerNoName'),
)

const onLogout = () => {
  authStore.logout()
}
</script>

<style scoped>
/* Keep the outlined logout button readable on the green background. */
.admin-hub-banner :deep(.p-button-outlined) {
  border-color: rgba(255, 255, 255, 0.7);
  color: #fff;
}
.admin-hub-banner :deep(.p-button-outlined:hover) {
  background: rgba(255, 255, 255, 0.15);
}
</style>
